import LyftBanner from "./LyftBanner";
import LyftTeamlogo from "./LyftTeamlogo";
import { lazy, Suspense } from "react";

const LyftFeature = lazy(() => import("./LyftFeature"));
const LyftIntro = lazy(() => import("./LyftIntro"));
const LyftMinimum = lazy(() => import("./LyftMinimum"));
const LyftPlace = lazy(() => import("./LyftPlace"));
const LyftSupport = lazy(() => import("./LyftSupport"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const OnDemandWork = lazy(() => import("../onDemand/OnDemandWork"));

const faqData = [
  {
    id: "0",
    question: "01. What is Lyft Clone app?",
    answer: "The Lyft Clone App is a ready-to-launch, white-label ride-hailing app solution that replicates the core features of Lyft. It includes passenger and driver apps, along with an admin dashboard, built to offer seamless booking, GPS tracking, payment integration, and more. It allows startups and enterprises to enter the ride-sharing market quickly with a fully scalable and customizable platform.",
  },
  {
    id: "1",
    question: "02. What is the cost of the Lyft clone script?",
    answer: "The pricing depends on the features you choose, the level of customization, and your deployment needs. We offer flexible packages suitable for startups and enterprises alike. Contact our team for a detailed quote tailored to your requirements.",
  },
  {
    id: "2",
    question: "03. How does the Lyft clone app work?",
    answer: "The app connects passengers and drivers in real-time. Riders can book a ride, track drivers, and make payments via the app. Drivers receive trip requests, navigate routes, and manage earnings—all from their dashboard. Admins monitor and manage the system from a centralized panel.",
  },
  {
    id: "3",
    question: "04. What are the top Lyft Clone App features?",
    answer: "Our Lyft Clone App offers live ride tracking, smart fare calculation, in-app payments, driver and user management, real-time chat, reviews and ratings, trip history, multi-language support, and a powerful admin dashboard—all designed for seamless ride-hailing operations.",
  },
  {
    id: "4",
    question: "05. What are the Lyft Clone App benefits?",
    answer: "Lyft Clone app is cost-effective, quick to deploy, highly scalable, and fully customizable. You get complete source code, enhanced branding flexibility, automated processes, and a market-ready platform to launch and grow your ride-hailing business with confidence.",
  },
  {
    id: "5",
    question: "06. How can I contact your technical support team?",
    answer: "You can reach our support team via email, live chat, or your client dashboard. We offer end-to-end technical support, including installation assistance, bug fixes, performance monitoring, and periodic updates through timely assistance with a dedicated support manager assigned to your project for seamless communication.",
  },
];

export default function LyftClone() {
  return (
    <>
      <LyftBanner />
      <LyftTeamlogo />

      <Suspense fallback={null}>
        <LyftIntro />
        <LyftFeature />
        <LyftPlace />
        <LyftMinimum />
        <LyftSupport />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
